import { Link } from 'react-router-dom';
import { NavigateRoutesEnum } from '@routing/routesEnum';
import { hasOwnPropertyTS } from '@components/utils';



const About = (): JSX.Element => {

	return (
		<div className='footer-menu about-section'>

			<Link to={NavigateRoutesEnum.about} className='disable-selection'>
				Proč Vetlímce
			</Link>

			<Link to={NavigateRoutesEnum.partners} className='disable-selection'>
				Pro partnery
			</Link>

			<Link to={NavigateRoutesEnum.contact} className='disable-selection'>
				Kontakt
			</Link>

			<Link to={'#'} className='disable-selection' onClick={() => {
					if (hasOwnPropertyTS(window, 'Cookiebot')
						&& window.Cookiebot
						&& hasOwnPropertyTS(window.Cookiebot, 'show')
						&& window.Cookiebot.show) {
							(window.Cookiebot as any).show();
						}
				}}>
				Změna souhlasu s cookies
			</Link>
			
		</div>
	);
}

export default About;